import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

class BlogSlider {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.swiperEl = this.root.querySelector('[data-blog-slider-swiper]');
        this.paginationEl = this.root.querySelector('[swiper-pagination]');
        this.swiper = null;

        return true;
    }

    init() {
        this.handleSwiper();
        window.addEventListener('resize', () => this.handleSwiper());
    }

    setSwiper() {
        if (!this.swiperEl || this.swiper) return;

        this.swiper = new Swiper(this.swiperEl, {
            modules: [Pagination],
            speed: 650,
            slidesPerView: 1.08,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 1.5,
                },
            },
            pagination: {
                el: this.paginationEl,
                type: 'progressbar',
            },
        });
    }

    destroySwiper() {
        if (!this.swiper) return;

        this.swiper.destroy(true, true);
        this.swiper = null;
    }

    handleSwiper() {
        if (window.innerWidth >= 1024) {
            this.destroySwiper();
        } else {
            this.setSwiper();
        }
    }
}

const sections = document.querySelectorAll('[data-blog-slider]');
const setBlogSlider = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new BlogSlider(el);
    });
};

setBlogSlider(sections);
